










































































































































































































import { Component, Vue } from 'vue-property-decorator'
import api from '@/services/api'
import chat from '@/services/chat'
import { take } from 'rxjs/operators'

@Component
export default class extends Vue {
    nothing = false
    cardMenuOpened = false
    tooLittleRated = false
    genderId: 'him' | 'her'
    matchedCards: any[] = []
    selectedCardForMenu: any
    open(link: string) {
        setTimeout(() => {
            window.open(link)
        }, 300)
    }
    async created() {
        const user = await api.user.pipe(take(1)).toPromise()
        this.genderId = user.gender === 'f' ? 'her' : 'him'
        if (user.ratedCards === undefined) {
            return (this.nothing = true)
        }
        if (user.ratedCards.length < 15) {
            return (this.tooLittleRated = true)
        }
        console.log(user)
        const data = await api.request('get', 'idea-cards/shared')
        this.matchedCards = data.data
        console.log(data)
    }
    shareOnChat() {
        chat.sendMessage(undefined, [{
            t: 'mc',
            d: this.selectedCardForMenu._id
        }])
        this.$router.push('/chat')
    }
    closeMenuIfDirectClick(event: MouseEvent) {
        if (event.target === event.currentTarget) {
            this.cardMenuOpened = false
        }
    }
    showCardMenu(card: any) {
        this.selectedCardForMenu = card
        this.cardMenuOpened = true
    }
}
